import React, { useEffect, useState } from 'react'
import './BookItem.css'
import '../../Pages/ViewAd/ViewAd.css'
import userApi from '../../Common/Api/UserApi'
import Cookies from "js-cookie";

import { useSelector } from 'react-redux'
import { useNavigate, Link } from 'react-router-dom';


const BookItem = (props) => {

  const navigate = useNavigate();
  const { BookWormUser } = useSelector((state) => state)

  const [inCart, setInCart] = useState(false)
  const handleViewBook = () => {
    navigate(`/viewBook/${props.id}`)
  }

  const handleAddtoCart = async () => {

    userApi.post('/user/add-to-cart', {
      user: {
        _id: BookWormUser.userInfo._id
      },
      adId: props.id
    },
      {
        headers: {
          'Authorization': `Bearer ${Cookies.get('token')}`
        }
      }).then(()=>alert("Book Added to your Cart !")).catch(err => {
        console.log('status : ', err);

        if (err.response.status == 404) {
          alert("This Item already Exists in your Cart");
        }
        
      })

  }

  const [toBuy, setToBuy] = useState([]);

  useEffect(() => {

    setToBuy([{ id: props.id, price: props.price, title: props.name, img: props.img,sellerId:props.sellerId }])

  }, [])



  return (
    <>
      <div className='book-card'>

        <div className='book-img-container'>
          <img src={props.img} alt="" className='book-img' />

          <div className='overlay-book'>
            <Link state={{books:toBuy}} to='/checkout'><div className='book-img-icon' id='bag'><i className="fa-solid fa-bag-shopping"></i></div></Link>
            <div onClick={() => handleViewBook()} className='book-img-icon' id='eye'><i className="fa-regular fa-eye"></i></div>
            <div className='book-img-icon' onClick={handleAddtoCart} id='cart'><i className="fa-solid fa-cart-plus"></i></div>
          </div>

        </div>

        <div className='book-details'>
          {/* <p>{props.categories.map((element)=>{
            return element.name
          })}</p> */}
          <h4>{props.name}</h4>
          <p>By - {props.author}</p>
          <b><p><i className="fa-solid fa-indian-rupee-sign"></i> {props.price}</p></b>
        </div>

      </div>

    </>

  )
}

export default BookItem